import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Loan } from "../../app/loan/shared/loan";
import { Center } from "../../app/master/center/shared/center.model";
import { Commonmaster } from "../commonmasters/commonmaster.model";
import { Applicationdate } from '../settings/changedate/shared/applicationdate';


@Injectable({
  providedIn: 'root'
})
export class CommonmastersService {

  constructor(private httpClient: HttpClient) { }

  getBaseUrl() {
    return environment.baseUrl;
  }

  selectedLoan :Loan;
  selectedCenter: Center;
  selectedCommonmaster : Commonmaster;

  FetchAutogeneratedNumber() {

    this.selectedCommonmaster = new Commonmaster;
    this.selectedCommonmaster.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];

    let body = this.selectedCommonmaster;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/AutoGeneratedNumber', body, { headers: headers });
  }

  // FetchCustomerList(){

  //   // this.selectedLoan= new Loan();
  //   // this.selectedLoan.IsCustomerSearch = true;
  //   // this.selectedLoan.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
  //   // this.selectedLoan.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
  //   // this.selectedLoan.EmployeeId =+ JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
  //   // this.selectedLoan.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

  //   let body = null;
  //   const headers = new HttpHeaders();
  //   headers.set('Content-Type', 'application/json; charset=utf-8');
  //   return this.httpClient.post<any>(this.getBaseUrl() + 'api/Customers/FetchList', body, { headers: headers });
  // }

  GetCustomerAddressById(CustomerId : any){

    this.selectedLoan= new Loan();
    this.selectedLoan.Id  = CustomerId;
    this.selectedLoan.IsCustomerSearch = true;
    this.selectedLoan.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedLoan.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedLoan.EmployeeId =+ JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedLoan.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.selectedLoan;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Customers/Fetch', body, { headers: headers });
  }

  FetchScheme() {

    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/Scheme', body, { headers: headers });
  }

  FetchLoanPurpose() {

    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/LoanPurpose', body, { headers: headers });
  }

  FetchLoanType(){

    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/LoanType', body, { headers: headers });
  }

  FetchAgentList() {

    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/Agent', body, { headers: headers });
  }

  FetchPaymentMode() {

    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/PaymentMode', body, { headers: headers });
  }

  GetCategoryList(){
    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() +  'api/CommonMaster/LoanCategory', body,{headers: headers});
  }

  GetBranchList(){

    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() +  'api/CommonMaster/Branch', body,{headers: headers});
  }

  GetOccupationsList(){

    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() +  'api/CommonMaster/Occupations', body,{headers: headers});
  }

  GetOccupationStatusList(){
    let body = '';
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() +  'api/CommonMaster/OccupationStatus', body,{headers: headers});
  }

  GetRelationList(){

    let body = '';
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() +  'api/CommonMaster/Relation', body,{headers: headers});
  }

  GetMartialStatusList(){
    let body = '';
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() +  'api/CommonMaster/MartialStatus', body,{headers: headers});
   
  }

  GetIdProofList(){

    let body = '';
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() +  'api/CommonMaster/IdProofs', body,{headers: headers});
  }

  GetCountryList(){
        
    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() +  'api/CommonMaster/Country', body,{headers: headers});
  }

  GetStateList(){
        
    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() +  'api/CommonMaster/State', body,{headers: headers});
  }

  GetDistrictsList(){
        
    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() +  'api/CommonMaster/Districts', body,{headers: headers});
  }

  GetAgentList(){
            
    let body = '';
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() +  'api/CommonMaster/Agent', body,{headers: headers});
  }

   FetchAreaList(){

    let body = '';
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() +  'api/CommonMaster/FetchArea', body,{headers: headers});
  }

   FetchDepositTypeList(){

  let body = '';
  const headers = new HttpHeaders();
  headers.set('Content-Type', 'application/json; charset=utf-8');
  return this.httpClient.post<any>( this.getBaseUrl() +  'api/CommonMaster/DepositType', body,{headers: headers});
   }
  
  FetchBankList(){

  let body = '';
  const headers = new HttpHeaders();
  headers.set('Content-Type', 'application/json; charset=utf-8');
  return this.httpClient.post<any>( this.getBaseUrl() +  'api/CommonMaster/Bank', body,{headers: headers});
}
    
  FetchRedeptionTypeList(){
  let body = '';
  const headers = new HttpHeaders();
  headers.set('Content-Type', 'application/json; charset=utf-8');
  return this.httpClient.post<any>( this.getBaseUrl() +  'api/CommonMaster/RedeptionType', body,{headers: headers});
}

FetchStaffList(){
  let body = '';
  const headers = new HttpHeaders();
  headers.set('Content-Type', 'application/json; charset=utf-8');
  return this.httpClient.post<any>( this.getBaseUrl() +  'api/CommonMaster/Staff', body,{headers: headers});
}

// FetchCenterList() {
//   var body = '';
//   const headers = new HttpHeaders();
//   headers.set('Content-Type', 'application/json; charset=utf-8');
//   return this.httpClient.post<any>( this.getBaseUrl() +  'api/Center/FetchList', body,{headers: headers});
// }


// CentreList by branchId 
FetchCenterList(){
    
  this.selectedCenter  = new Center();
  this.selectedCenter.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
  this.selectedCenter.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
  this.selectedCenter.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
  this.selectedCenter.EmployeeId =+ JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
  this.selectedCenter.SaasId =  JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

  let body =  this.selectedCenter;
  const headers = new HttpHeaders();
  headers.set('Content-Type', 'application/json; charset=utf-8');
  return this.httpClient.post<any>( this.getBaseUrl() +  'api/Center/FetchList', body,{headers: headers});
 }

 FetchCentersBybranchId(branchId : any){
    
  this.selectedCenter  = new Center();
  this.selectedCenter.BranchId = + branchId;
  this.selectedCenter.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
  this.selectedCenter.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
  this.selectedCenter.EmployeeId =+ JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
  this.selectedCenter.SaasId =  JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

  let body =  this.selectedCenter;
  const headers = new HttpHeaders();
  headers.set('Content-Type', 'application/json; charset=utf-8');
  return this.httpClient.post<any>( this.getBaseUrl() +  'api/Center/FetchList', body,{headers: headers});
 }

  FetchStaffListById(Number: any) {

    this.selectedCommonmaster = new Commonmaster;
    this.selectedCommonmaster.Id = Number;
    this.selectedCommonmaster.IsSurvey = Number; // survey staff 
    let body = this.selectedCommonmaster;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/StaffbyId', body, { headers: headers });
  }

  GetFinancialYearList(){

    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() + 'api/CommonMaster/FinancialYear', body, {headers: headers });
  }

  GetDesignationList(){

    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() + 'api/CommonMaster/Designation', body, {headers: headers });
  }

  GetRoleList(){

    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() + 'api/CommonMaster/Roles', body, {headers: headers });
  }

  GetApplicationDate(branchId : any){

   let selectedApplicationdate  = new Applicationdate();
    selectedApplicationdate.BranchId = + branchId;
    selectedApplicationdate.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    selectedApplicationdate.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    selectedApplicationdate.EmployeeId =+ JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    selectedApplicationdate.SaasId =  JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
  
    let body =  selectedApplicationdate;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() + 'api/ApplicationDateTime/Fetch', body, {headers: headers });
  }

  GetCustomerListByCentreId(SearchData : any){

    this.selectedLoan = new Loan();
    this.selectedLoan.CentreId  = SearchData.CentreId;
    this.selectedLoan.BranchId = + SearchData.BranchId;

    this.selectedLoan.IsCustomerSearch = true;
    this.selectedLoan.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    // this.selectedLoan.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedLoan.EmployeeId =+ JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedLoan.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.selectedLoan;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Customers/FetchList', body, { headers: headers });
  }



}
